import {
  performanceMeasure,
  performanceClearMarks,
  PerformancePoint,
} from './performance';

export type PerformancePointLegacy =
  // Trip overview - itinerary
  | 'TripOverviewPageRenderedLegacy' // Triggered when loading TripOverview page is first rendered
  | 'FirstItineraryRequested' // Triggered before sending request to smart search
  | 'FirstItineraryReceived' // Triggered when response for first day is loaded from smart search
  | 'FirstItineraryRendered' // Triggered when itinerary for first day is rendered

  // HotelSelection
  | 'HotelSelectionViewInitiated'
  | 'HotelSelectionListRendered'

  // ActivitySelection
  | 'ActivitySelectionViewInitiated'
  | 'ActivitySelectionListRendered'

  // Common Selection
  | 'DestinationAvailabilityRequested' // Triggered on SmartSearch request
  | 'DestinationAvailabilityReceived'; // Triggered on SmartSearch response;

interface FirstItineraryPerformanceMeasures {
  timeToTripOverviewPageRendered: number;
  timeToFirstItineraryAvailabilityRequestMs: number;
  timeToFirstItineraryAvailabilityReceivedMs: number;
  timeToFirstItineraryRenderedMs: number;
  totalTimeRequiredToRenderFirstItinerary: number;
}

/**
 * @deprecated
 */
export function measureFirstItineraryRenderPerformance(): Promise<FirstItineraryPerformanceMeasures> {
  return new Promise((resolve) => {
    const observerCallback: PerformanceObserverCallback = (list, observer) => {
      list.getEntries().forEach((entry) => {
        if (
          (entry.name as PerformancePointLegacy) === 'FirstItineraryRendered'
        ) {
          const timeToTripOverviewPageRendered = performanceMeasure(
            PerformancePoint.AppInitiated,
            'TripOverviewPageRenderedLegacy'
          ).duration;
          const timeToFirstItineraryAvailabilityRequestMs = performanceMeasure(
            PerformancePoint.AppInitiated,
            'FirstItineraryRequested'
          ).duration;
          const timeToFirstItineraryAvailabilityReceivedMs = performanceMeasure(
            'FirstItineraryRequested',
            'FirstItineraryReceived'
          ).duration;
          const timeToFirstItineraryRenderedMs = performanceMeasure(
            'FirstItineraryReceived',
            'FirstItineraryRendered'
          ).duration;
          const totalTimeRequiredToRenderFirstItinerary = performanceMeasure(
            PerformancePoint.AppInitiated,
            'FirstItineraryRendered'
          ).duration;

          observer.disconnect();

          resolve({
            timeToTripOverviewPageRendered,
            timeToFirstItineraryAvailabilityRequestMs,
            timeToFirstItineraryAvailabilityReceivedMs,
            timeToFirstItineraryRenderedMs,
            totalTimeRequiredToRenderFirstItinerary,
          });
        }
      });
    };

    const observer = new PerformanceObserver(observerCallback);

    observer.observe({ entryTypes: ['mark'] });
  });
}

interface HotelSelectionPerformanceMeasures {
  timeToHotelSelectionViewAvailabilityRequestMs: number;
  timeToHotelSelectionViewAvailabilityReceivedMs: number;
  timeToHotelSelectionListRenderedMs: number;
  totalTimeRequiredToRenderHotelSelectionList: number;
}

/**
 * @deprecated
 */
export function measureHotelSelectionListRenderPerformance(): Promise<HotelSelectionPerformanceMeasures> {
  return new Promise((resolve) => {
    const observerCallback: PerformanceObserverCallback = (list) => {
      list.getEntries().forEach((entry) => {
        if (
          (entry.name as PerformancePointLegacy) ===
          'HotelSelectionListRendered'
        ) {
          const timeToHotelSelectionViewAvailabilityRequestMs =
            performanceMeasure(
              'HotelSelectionViewInitiated',
              'DestinationAvailabilityRequested'
            ).duration;
          const timeToHotelSelectionViewAvailabilityReceivedMs =
            performanceMeasure(
              'DestinationAvailabilityRequested',
              'DestinationAvailabilityReceived'
            ).duration;
          const timeToHotelSelectionListRenderedMs = performanceMeasure(
            'DestinationAvailabilityReceived',
            'HotelSelectionListRendered'
          ).duration;
          const totalTimeRequiredToRenderHotelSelectionList =
            performanceMeasure(
              'HotelSelectionViewInitiated',
              'HotelSelectionListRendered'
            ).duration;

          performanceClearMarks('DestinationAvailabilityRequested');
          performanceClearMarks('DestinationAvailabilityReceived');

          observer.disconnect();

          resolve({
            timeToHotelSelectionViewAvailabilityRequestMs,
            timeToHotelSelectionViewAvailabilityReceivedMs,
            timeToHotelSelectionListRenderedMs,
            totalTimeRequiredToRenderHotelSelectionList,
          });
        }
      });
    };

    const observer = new PerformanceObserver(observerCallback);

    observer.observe({ entryTypes: ['mark'] });
  });
}

interface ActivitySelectionPerformanceMeasures {
  timeToActivitySelectionViewAvailabilityRequestMs: number;
  timeToActivitySelectionViewAvailabilityReceivedMs: number;
  timeToActivitySelectionListRenderedMs: number;
  totalTimeRequiredToRenderActivitySelectionList: number;
}

/**
 * @deprecated
 */
export function measureActivitySelectionListRenderPerformance(): Promise<ActivitySelectionPerformanceMeasures> {
  return new Promise((resolve) => {
    const observerCallback: PerformanceObserverCallback = (list) => {
      list.getEntries().forEach((entry) => {
        if (
          (entry.name as PerformancePointLegacy) ===
          'ActivitySelectionListRendered'
        ) {
          const timeToActivitySelectionViewAvailabilityRequestMs =
            performanceMeasure(
              'ActivitySelectionViewInitiated',
              'DestinationAvailabilityRequested'
            ).duration;
          const timeToActivitySelectionViewAvailabilityReceivedMs =
            performanceMeasure(
              'DestinationAvailabilityRequested',
              'DestinationAvailabilityReceived'
            ).duration;
          const timeToActivitySelectionListRenderedMs = performanceMeasure(
            'DestinationAvailabilityReceived',
            'ActivitySelectionListRendered'
          ).duration;
          const totalTimeRequiredToRenderActivitySelectionList =
            performanceMeasure(
              'ActivitySelectionViewInitiated',
              'ActivitySelectionListRendered'
            ).duration;

          performanceClearMarks('DestinationAvailabilityRequested');
          performanceClearMarks('DestinationAvailabilityReceived');

          observer.disconnect();

          resolve({
            timeToActivitySelectionViewAvailabilityRequestMs,
            timeToActivitySelectionViewAvailabilityReceivedMs,
            timeToActivitySelectionListRenderedMs,
            totalTimeRequiredToRenderActivitySelectionList,
          });
        }
      });
    };

    const observer = new PerformanceObserver(observerCallback);

    observer.observe({ entryTypes: ['mark'] });
  });
}
